import { StoryCardProps } from "../interfaces/interfaces.d";

export const storyCardData: Array<StoryCardProps> = [
    {
        title:"Overdraft (Bonpellz enabler)",
        text:"We believe the future belongs to the children so we have decided leveling the playing field for them by enabling the parent with ease, hit target savings goals for the kid through the provision of credit money."
    },
    {
        title:" Bz Pool",
        text:" A digital wallet that allows you save, withdraw, transfer and manage your funds for free and at will "
    },

]